import React from 'react'
import { Popconfirm, Button, Icon, Progress, Tooltip } from 'antd'
import moment from 'moment'
import {sanitize_path} from "../../../utils"
import './styles.scss'

export default ({file, on_cancel}) => {
  let {
    media_id, created, finished, id,
    progress, time_left, status, error,
    preset,
    destination:{bucket_name:destination_bucket, path:destination},
    source:{bucket_name, path}
  } = (file || {})

  if(progress === '100.0')
  {
    status   = 'Finished'
    progress = 0
  }

  if(status === 'Error')
    progress = 0

  return (
    <div className='file-item columnWrap'>

      <div>
        <Icon type="video-camera" />
        <div>
          <span className={'ribbon small'}>{sanitize_path(path)}</span>
          <div className={'destination'}>
            <span className={'small'}>{'['+ preset + ']'}</span>
            <span>{sanitize_path(destination_bucket + '/' + destination)}</span>
          </div>
        </div>
      </div>

      <span>{media_id}</span>

      {/*<span>{moment(created).format('MMM-DD-YY')}</span>*/}

      {
        finished ? <span/> :
          ((time_left && time_left !== '0') ? <span>{moment.duration(time_left/1000, "seconds").humanize(true)}</span>:<span/>)
      }

      {
        status === 'Finished' ? <div><span className={'done ribbon medium'}>{"Done"}</span></div> :
          null
      }

      {
        status === 'Stopped' ? <div><span className={'done ribbon medium'}>{"Stopped"}</span></div> :
          null
      }

      {
        status === 'New' ? <div><span className={'done ribbon medium'}>{"Processing..."}</span></div> :
          null
      }

      {
        status === 'Processing' ?
          <div>
            <Progress percent={parseFloat(progress) ? parseFloat(progress):0} status={'active'} />
            <Popconfirm title={'Are you sure to cancel ?'} placement="top" okText="Yes" cancelText="No" onConfirm={()=> on_cancel(file)}>
              <Button icon="close" size={'small'}/>
            </Popconfirm>
          </div> : null
      }

      {
        status === 'Error' ?
          <div className={'error'} >
            <Tooltip overlayClassName={'tooltip-error'} title={error}>
              <Icon type="exclamation-circle-o" />
            </Tooltip>
          </div> : null
      }
    </div>
  )
}
